


















import { Component, Vue } from "vue-property-decorator";
import DashboardTemplate from "@/views/Layouts/dashboard-template.vue";
import RecoveryWiki from "@/views/Wiki/RecoveryWiki.vue";
import ActivationWiki from "@/views/Wiki/ActivationWiki.vue";
import OverviewWiki from "@/views/Wiki/OverviewWiki.vue";
import GlossaryWiki from "@/views/Wiki/GlossaryWiki.vue";
import GroupsWiki from "@/views/Wiki/GroupsWiki.vue";
import StreamsWiki from "@/views/Wiki/StreamsWiki.vue";
import AssembleWiki from "@/views/Wiki/AssembleWiki.vue";
import APIWiki from "@/views/Wiki/APIWiki.vue";

@Component({
  components: {
    APIWiki,
    GroupsWiki,
    AssembleWiki,
    ActivationWiki,
    RecoveryWiki,
    GlossaryWiki,
    OverviewWiki,
    StreamsWiki,
    DashboardTemplate
  },
})
export default class Wiki extends Vue {
  private tabPosition: string = "left";
}
